<template>
    <div>
        <GenericCrud
            route-name="SettingsSecurityControls"
            route-action="list"
            :navbar-title="$t('settings.securityControl.buttonLabel')"
            :navbar-back-route-without-history="{ name: 'Settings' }"
            :main-list-filter-label="$t('settings.securityControl.filterLabel')"
            main-fist-scroll-to-selected
            :storeData="{
                mainListItems: {
                    action: 'tools/fetchSecurityControlItems',
                    payload: { force: true },
                    options: null,
                    itemText: 'title',
                    customized: {
                        property: 'customized',
                        color: 'primary lighten-4',
                    },
                },
                mainItemById: {
                    action: 'tools/fetchSecurityControlById',
                    payload: null,
                    options: null,
                },
                edit: {
                    action: 'tools/editSecurityControl',
                    payload: null,
                    options: null,
                    refetch: true,
                    hideButton: true
                },
                add: {
                    action: 'tools/createSecurityControlItem',
                    payload: null,
                    options: null,
                },
                delete: {
                    action: 'tools/deleteSecurityControl',
                    payload: null,
                    options: null,
                    hideButton: true
                },
                findUsage: {
                    action: 'tools/findUsageSecurityControl',
                    payload: null,
                    options: null,
                    hideButton: true
                },
                replace: {
                    action: 'tools/replaceSecurityControlInTool',
                    options: null,
                    hideButton: true
                },
            }"
            :newItemModelFields="{
                controlId: null,
                customized: true,
                title: null,
                locale: currentLanguage,
                translations: defaultTranslations,
            }"
        >
            <template v-slot:editorMask="x">
                <EditorMask
                    v-model="x.selectedMainItem"
                    :key="x.id"
                    :available-languages="availableLanguages"
                    :current-language="currentLanguage"
                    :isWaiting="x.isWaiting"
                    :isModified="x.isModified"
                    @modified="x.onSetModified"
                    @onSaveItem="x.onSaveItem"
                    @onDeleteItem="x.onDeleteItem"
                    @onFindUsage="x.onFindUsage"
                    @onCreateItem="x.onCreateItem"
                />
            </template>
        </GenericCrud>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import GenericCrud from '@/components/generic/GenericCrud.vue';
import EditorMask from './EditorMask.vue';

export default {
    name: 'SettingsSecurityControlsIndex',
    components: {
        GenericCrud,
        EditorMask,
    },
    i18n: {
        messages: {
            en: require('@/locales/Settings/en.json'),
            de: require('@/locales/Settings/de.json'),
        },
    },
    computed: {
        ...mapGetters({
            availableLanguages: 'languageSettings/getAvailableLanguages',
            currentLanguage: 'languageSettings/getCurrentLanguage',
        }),
        defaultTranslations() {
            let translations = this.availableLanguages.map(x => {
                return { title: '', locale: x};
            });
            
            return translations.sort((a, b) => {
                return (b.locale === this.currentLanguage && a.locale !== this.currentLanguage) ? 1 : -1;
            });
        }
    },
};
</script>
